// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"510":"54013ab2","787":"de65b8a0"}[chunkId] + ".chunk.js";
};